import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { LinkElement } from '@els/els-react--link-element';
import RxStructureService from '@Services/RxStructureService';

import './StructureOpenInDatabase.scss';

export default function StructureOpenInDatabase({ metadata, subLinks, onOptionClick = noop }) {
  const openInDatabase = (db) => {
    RxStructureService.openInDatabase(db, get(metadata, 'originalSearchType'));
  };

  return (
    <ul role="menu" className="u-els-nowrap" aria-describedby="Structure available in these databases.">
      {subLinks.map((db) => (
        <li className="u-els-margin-bottom-1o2" key={db.databaseId}>
          <LinkElement
            href="#"
            iconSprite="ChevronRight"
            iconSize="xs"
            role="menuitem"
            className={cn(
              'u-els-margin-top-1o4',
              'u-els-margin-bottom-1o4',
              'e2e-drop-item',
              'e2e-open-in-database',
              `e2e-${kebabCase(db.label)}`
            )}
            onClick={(e) => {
              e.preventDefault();
              onOptionClick(db.label);
              openInDatabase(db);
            }}>
            {db.label}
          </LinkElement>
        </li>
      ))}
    </ul>
  );
}

StructureOpenInDatabase.propTypes = {
  metadata: PropTypes.object,
  subLinks: PropTypes.array,
  onOptionClick: PropTypes.func,
};
